var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReportOther = function SvgIconReportOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B6C3D6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.085 5.134a.95.95 0 0 0-.285.683v5.83c0 .858.674 1.553 1.506 1.553h4.997c.585 0 1.114-.357 1.348-.91l2.013-4.76c.467-1.102-.326-2.333-1.493-2.318l-3.668.02a.165.165 0 0 1-.158-.208l.733-2.904c.179-.713-.66-1.222-1.179-.715zM1.6 5.2a.4.4 0 0 0-.4.4v7.2c0 .22.18.4.4.4h1.6a.4.4 0 0 0 .4-.4V5.6a.4.4 0 0 0-.4-.4z"
  }))));
};
export default SvgIconReportOther;